import "./App.css";
import App from "./App.tsx";
import React, { StrictMode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { createTheme, ThemeProvider } from "@mui/material/styles";

document.addEventListener("DOMContentLoaded", function () {
    const queryClient = new QueryClient();
    const rootElement = document.getElementById("root")!;
    const root = createRoot(rootElement);

    const theme = createTheme({
        typography: {
            // In Chinese and Japanese the characters are usually larger,
            // so a smaller fontsize may be appropriate.
            fontSize: 12,
            h1: {
                fontFamily: "Proxima Nova Bold, Arial, sans-serif",
                color: "rgb(32, 41, 69)",
                textTransform: "uppercase",
            },
            h2: {
                fontFamily: "Proxima Nova Bold, Arial, sans-serif",
                color: "rgb(32, 41, 69)",
                textTransform: "uppercase",
            },
            h3: {
                fontFamily: "Proxima Nova Bold, Arial, sans-serif",
                color: "rgb(32, 41, 69)",
                textTransform: "uppercase",
            },
            h4: {
                fontFamily: "Proxima Nova Bold, Arial, sans-serif",
                color: "rgb(32, 41, 69)",
                textTransform: "uppercase",
            },
            h5: {
                fontFamily: "Proxima Nova Bold, Arial, sans-serif",
                color: "rgb(32, 41, 69)",
                textTransform: "uppercase",
            },
            h6: {
                fontFamily: "Proxima Nova Bold, Arial, sans-serif",
                color: "rgb(32, 41, 69)",
                textTransform: "uppercase",
            },
            body1: {
                fontFamily: "Proxima Nova Regular, Arial, sans-serif",
                fontSize: 20,
            },
            body2: {
                fontFamily: "Proxima Nova Regular, Arial, sans-serif",
                fontSize: 20,
                color: "#4d4d4dff",
            },
            caption: {
                fontFamily: "Proxima Nova Semi Bold, Arial, sans-serif",
                fontSize: 20,
                color: "#000000",
            },
        },
        palette:{
            primary: { main: "#0158a6" },
            secondary: { main: "#161f3b" },
        },
        components: {
            MuiCard: {
                styleOverrides: {
                    root: {
                        boxShadow: "unset",
                        borderRadius: "0px",
                        border: "1px solid rgba(32, 41, 69, 0.08)",
                    },
                },
            },
            MuiCardHeader: {
                styleOverrides: {
                    title: {
                        fontFamily: "Proxima Nova Bold, Arial, sans-serif",
                        fontSize: "1.5rem",
                        color: "rgb(32, 41, 69)",
                        textTransform: "uppercase",
                    },
                },
            },
        },
    });

    root.render(
        <StrictMode>
            <ThemeProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                    <App />
                </QueryClientProvider>
            </ThemeProvider>
        </StrictMode>,
    );
});
